import { AssetId } from "../../config/assets";

export interface SecurityScore {
  grade: string;
  score: number;
  sourceUrl: string;
  sourceName: string;
}

export const SECURITY_SCORES: Partial<Record<AssetId, SecurityScore>> = {
  sol: {
    grade: "B",
    score: 82.5,
    sourceUrl: "https://yieldcompass.fi/strategy/kyros-sol-restaking",
    sourceName: "YieldCompass",
  },
  jto: {
    grade: "B",
    score: 87.5,
    sourceUrl: "https://yieldcompass.fi/strategy/kyros-jto-liquid-staking",
    sourceName: "YieldCompass",
  },
};

export const formatSecurityScore = (securityScore: SecurityScore): string =>
  `${securityScore.grade} (${securityScore.score})`;
